import gql from 'graphql-tag';

export const DELETE_ACCOUNT = gql`
  mutation deleteAccount($accountDelete: DeleteAccountInput!) {
    deleteAccount(input: $accountDelete) {
      ... on DeleteAccountSuccess {
        ref
      }
      ... on DeleteAccountFailure {
        error {
          __typename
          message
          code
          reason
          ... on AccountValidationError {
            details {
              message
              code
              path {
                field
                path
              }
              reason
            }
          }
        }
      }
    }
  }
`;
